module.exports = __webpack_public_path__ + "static/media/Repartiendo.624cd9f5.svg";